import { Button } from 'ccs-ui-components';
import { IServiceOperationValidationModel } from '../../../../../../models';
import classes from './ServiceOperationFormWrapper.module.scss';
import ServiceOperationForm from './operation-form/ServiceOperationForm';
import ServiceOperationHeader from './form-header/ServiceOperationHeader';

interface IAddServiceOpsProps {
  isSaveClicked: boolean;
  onServiceOpsAdded: () => void;
  onServiceOperationEntered: (
    serviceOperationName: string,
    operationURL: string,
    operationVerb: string,
    serviceOperationFormData: IServiceOperationValidationModel,
  ) => void;
  onSaveValid: (value: boolean) => void;
  isEditButtonClick: boolean;
  editViewIndex: number;
  isAddNewServiceOperationClick: boolean;
  showOpsForm: boolean;
  showForms: () => void;
  isViewButtonClick: boolean
  viewMode: boolean
  serviceEdit: boolean,
}

const ServiceOperationFormWrapper = ({
  isSaveClicked,
  onServiceOpsAdded,
  showOpsForm,
  showForms,
  onServiceOperationEntered,
  onSaveValid,
  isEditButtonClick,
  editViewIndex,
  isAddNewServiceOperationClick,
  isViewButtonClick,
  viewMode,
  serviceEdit,
}: IAddServiceOpsProps) => (
  <div className={classes.container}>
    <Button
      onClick={showForms}
      className={classes['form-header-wrapper']}
      variant="outlined"
      data-testid="show-btn"
    >
      <ServiceOperationHeader showOpsForm={showOpsForm} />
    </Button>
    <div>
      <ServiceOperationForm
        isSaveClicked={isSaveClicked}
        onServiceOpsAdded={onServiceOpsAdded}
        onServiceOperationEntered={onServiceOperationEntered}
        onSaveValid={onSaveValid}
        showOpsForm={showOpsForm}
        isEditButtonClick={isEditButtonClick}
        editViewIndex={editViewIndex}
        isAddNewServiceOperationClick={isAddNewServiceOperationClick}
        isViewButtonClick={isViewButtonClick}
        serviceEdit={serviceEdit}
        viewMode={viewMode}
      />
    </div>
  </div>
);

export default ServiceOperationFormWrapper;
